// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__TpwhH","title":"Info_title__2Wz4u","links":"Info_links__1Ty70","link":"Info_link__2hCQI","logo":"Info_logo__363k9"};